// Default invoice template based on PageFacturae.vue
// This is almost an exact copy to ensure all fields are supported
export const DEFAULT_INVOICE_TEMPLATE = `<div class="invoiceViewer" v-if="invoiceable" :class="page.pageNum == 0 ? 'fist__page__padding' : ''">
  <div style="padding-left: 16px;" v-if="page.showHeader">
    <!-- QR Code and Logo Row -->
    <div v-if="invoiceable.qr_url" style="display: flex; align-items: flex-start; margin-bottom: 8px;">
      <div style="text-align: center; margin-right: 16px;">
        <small style="font-size: 11px;">QR tributario:</small><br>
        <img :src="invoiceable.qr_url" alt="Código QR" width="120" height="120"><br>
        <small style="font-size: 10px;">Factura verificable en la sede electrónica de la AEAT</small>
      </div>
      <div style="margin-left: auto;" v-if="configuration && configuration.path_url">
        <img :src="configuration.path_url" alt="Logo" style="max-height: 140px; max-width: 220px;">
      </div>
    </div>

    <!-- Main Content -->
    <div style="display: flex;">
      <div style="flex: 1;">
        <!-- Rectificative Header -->
        <div v-if="invoiceable.rectificative" style="margin-bottom: 8px;">
          <p style="font-size: 18px; font-weight: bold; margin: 0;">FACTURA RECTIFICATIVA</p>
          <p style="margin: 0;" v-if="rectified_inv">
            Rectifica la factura {{ rectified_inv.invoice_number }} del {{ formatInvoiceDate(rectified_inv.invoice_date) }}
          </p>
        </div>

        <!-- Invoice Number -->
        <div style="display: flex; justify-content: space-between; margin-bottom: 4px;">
          <div style="font-weight: bold;">
            <p style="margin: 0;"><b>Número {{invoiceable.name}}: </b>{{invoiceable.invoice_number}}</p>
          </div>
          <div v-if="invoiceable.type == 'invoice' && invoiceable.external_invoice_number" style="font-size: 12px;">
            <p style="margin: 0;"><b>Número factura externo: </b>{{invoiceable.external_invoice_number}}</p>
          </div>
        </div>

        <!-- Dates Row 1 -->
        <div style="display: flex; justify-content: space-between; font-size: 12px; margin-bottom: 2px;">
          <div><p style="margin: 0;"><b>Fecha {{invoiceable.name}}: </b>{{ formatInvoiceDate(invoiceable.invoice_date) }}</p></div>
          <div><p style="margin: 0;"><b>Fecha vencimiento: </b>{{ formatInvoiceDate(invoiceable.invoice_due_date) }}</p></div>
        </div>

        <!-- Dates Row 2 -->
        <div style="display: flex; justify-content: space-between; font-size: 12px; margin-bottom: 2px;">
          <div><p style="margin: 0;"><b>Fecha inicio: </b>{{ formatInvoiceDate(invoiceable.start_date) }}</p></div>
          <div><p style="margin: 0;"><b>Fecha final: </b>{{ formatInvoiceDate(invoiceable.end_date) }}</p></div>
        </div>

        <!-- Signing Time -->
        <div v-if="invoiceable.signing_time" style="font-size: 12px; margin-bottom: 2px;">
          <p style="margin: 0;"><b>Fecha firma: </b>{{ invoiceable.signing_time }}</p>
        </div>

        <v-divider style="margin: 8px 0; border-width: 2px; border-color: var(--v-primary_blue-base);"></v-divider>

        <!-- Supplier -->
        <p style="font-weight: bold; margin: 4px 0;">Emisor</p>
        <div style="display: flex; gap: 16px; font-size: 12px;">
          <div style="flex: 1;">
            <div v-if="invoiceable.supplier.type == 'juridica'">
              <p style="margin: 0;"><b>Razón social: </b>{{invoiceable.supplier.business_name}}</p>
            </div>
            <div v-else>
              <p style="margin: 0;"><b>Nombre fiscal: </b>{{ invoiceable.supplier.name }} {{ invoiceable.supplier.first_surname }} {{ invoiceable.supplier.second_surname }}</p>
            </div>
            <div>
              <p style="margin: 0;"><b>Domicilio fiscal: </b>{{ invoiceable.supplier.address }}</p>
              <p style="margin: 0; padding-left: 110px;">{{ invoiceable.supplier.post_code }} {{ invoiceable.supplier.city }}</p>
              <p style="margin: 0; padding-left: 110px;">{{ invoiceable.supplier.province }}</p>
            </div>
          </div>
          <div style="flex: 1;">
            <p style="margin: 0;"><b>NIF/CIF: </b>{{invoiceable.supplier.cif}}</p>
            <p style="margin: 0;" v-if="invoiceable.supplier.bank_account_number"><b>Número de cuenta: </b>{{invoiceable.supplier.bank_account_number}}</p>
            <p style="margin: 0;" v-if="invoiceable.supplier.type == 'juridica' && invoiceable.supplier.trade_name"><b>Nombre Comercial: </b>{{invoiceable.supplier.trade_name}}</p>
            <p style="margin: 0;" v-if="invoiceable.supplier.email"><b>Email: </b>{{invoiceable.supplier.email}}</p>
            <div v-if="invoiceable.supplier.phone" style="display: flex; gap: 16px;">
              <p style="margin: 0;"><b>Teléfono:</b> {{ invoiceable.supplier.phone }}</p>
              <p style="margin: 0;" v-if="invoiceable.supplier.website"><b>Web:</b> {{ invoiceable.supplier.website }}</p>
            </div>
          </div>
        </div>

        <!-- Customer -->
        <template v-if="invoiceable.type != 'ticket'">
          <v-divider style="margin: 8px 0; border-width: 2px; border-color: var(--v-primary_blue-base);"></v-divider>
          <p style="font-weight: bold; margin: 4px 0;">Receptor</p>
          <div style="display: flex; gap: 16px; font-size: 12px;">
            <div style="flex: 1;">
              <div v-if="invoiceable.customer.type == 'juridica'">
                <p style="margin: 0;"><b>Razón social: </b>{{invoiceable.customer.business_name}}</p>
              </div>
              <div v-else>
                <p style="margin: 0;"><b>Nombre fiscal: </b>{{ invoiceable.customer.name }} {{ invoiceable.customer.first_surname }} {{ invoiceable.customer.second_surname }}</p>
              </div>
              <div>
                <p style="margin: 0;"><b>Domicilio fiscal: </b>{{ invoiceable.customer.address }}</p>
                <p style="margin: 0; padding-left: 110px;">{{ invoiceable.customer.post_code }} {{ invoiceable.customer.city }}</p>
                <p style="margin: 0; padding-left: 110px;">{{ invoiceable.customer.province }}</p>
              </div>
            </div>
            <div style="flex: 1;">
              <p style="margin: 0;"><b>NIF/CIF: </b>{{invoiceable.customer.cif}}</p>
              <p style="margin: 0;" v-if="invoiceable.customer.type == 'juridica' && invoiceable.customer.trade_name"><b>Nombre Comercial: </b>{{invoiceable.customer.trade_name}}</p>
              <p style="margin: 0;" v-if="invoiceable.customer.DIRe"><b>DIRe:</b> {{ invoiceable.customer.DIRe }}</p>
              <p style="margin: 0;" v-if="invoiceable.customer.accounting_office"><b>Despacho contable:</b> {{ invoiceable.customer.accounting_office }}</p>
              <p style="margin: 0;" v-if="invoiceable.customer.management_body"><b>Órgano de gestión:</b> {{ invoiceable.customer.management_body }}</p>
              <p style="margin: 0;" v-if="invoiceable.customer.processing_unit"><b>Unidad tramitadora:</b> {{ invoiceable.customer.processing_unit }}</p>
              <p style="margin: 0;" v-if="invoiceable.customer.proposing_body"><b>Órgano proponente:</b> {{ invoiceable.customer.proposing_body }}</p>
            </div>
          </div>
        </template>
      </div>

      <!-- Logo (when no QR) -->
      <div v-if="!invoiceable.qr_url && configuration && configuration.path_url" style="width: 200px; margin-left: 16px;">
        <img :src="configuration.path_url" alt="Logo" style="max-width: 100%; max-height: 140px;">
      </div>
    </div>
  </div>

  <!-- Details Header -->
  <div style="padding: 8px; margin-top: 16px; background-color: var(--v-primary_blue-base);" v-if="page.showHeader">
    <p style="margin: 0; margin-left: 8px; font-weight: bold; color: white;">
      Detalles
      <span v-if="invoiceable.type == 'budget'">del presupuesto</span>
      <span v-else-if="invoiceable.type == 'delivery_note'">del albarán</span>
      <span v-else-if="invoiceable.type == 'proforma'">de la proforma</span>
      <span v-else-if="invoiceable.type == 'ticket'">del ticket</span>
      <span v-else>de la factura</span>
    </p>
  </div>

  <!-- Lines Table -->
  <table cellspacing="0" cellpadding="0" style="width: 100%; border-collapse: collapse; font-size: 11px; border: 1px solid #E6E6E6;">
    <thead style="background-color: #F4F4F4; color: #565656; font-weight: 600;" v-if="page.showLinesHeader">
      <tr>
        <th style="text-align: left; padding: 8px; border: 1px solid #E6E6E6;">Descripción</th>
        <th style="text-align: center; padding: 8px; border: 1px solid #E6E6E6;">Cantidad</th>
        <th style="text-align: center; padding: 8px; border: 1px solid #E6E6E6;">Precio unitario</th>
        <th style="text-align: center; padding: 8px; border: 1px solid #E6E6E6;">Descuento %</th>
        <th style="text-align: center; padding: 8px; border: 1px solid #E6E6E6;">{{tax_type_to_show}}</th>
        <th style="text-align: center; padding: 8px; border: 1px solid #E6E6E6;">Retención</th>
        <th style="text-align: right; padding: 8px; border: 1px solid #E6E6E6;">Total</th>
      </tr>
    </thead>
    <tbody v-if="page.showLines" style="font-weight: 400; color: #565656;">
      <!-- Proforma Header -->
      <tr v-if="proformaHeader">
        <td colspan="7" style="padding: 6px; border: 1px solid #E6E6E6;">
          <b v-if="proformaHeader.budget_number && proformaHeader.budget_date">
            Proforma {{ proformaHeader.budget_number }} del {{ formatInvoiceDate(proformaHeader.budget_date) }}
          </b>
          <b v-else-if="proformaHeader.budget_number">Proforma {{ proformaHeader.budget_number }}</b>
          <b v-else-if="proformaHeader.budget_date">Fecha de la proforma: {{ formatInvoiceDate(proformaHeader.budget_date) }}</b>
          <b v-if="proformaHeader.record_reference && proformaHeader.record_reference_date"> (Expediente {{ proformaHeader.record_reference }} del {{ formatInvoiceDate(proformaHeader.record_reference_date) }})</b>
          <b v-else-if="proformaHeader.record_reference"> (Expediente {{ proformaHeader.record_reference }})</b>
          <b v-else-if="proformaHeader.record_reference_date"> (Fecha del expediente: {{ formatInvoiceDate(proformaHeader.record_reference_date) }})</b>
        </td>
      </tr>

      <!-- Budget Header -->
      <tr v-if="presupuestoHeader">
        <td colspan="7" style="padding: 6px; border: 1px solid #E6E6E6;">
          <b v-if="presupuestoHeader.budget_number && presupuestoHeader.budget_date">
            Presupuesto {{ presupuestoHeader.budget_number }} del {{ formatInvoiceDate(presupuestoHeader.budget_date) }}
          </b>
          <b v-else-if="presupuestoHeader.budget_number">Presupuesto {{ presupuestoHeader.budget_number }}</b>
          <b v-else-if="presupuestoHeader.budget_date">Fecha del presupuesto: {{ formatInvoiceDate(presupuestoHeader.budget_date) }}</b>
          <b v-if="presupuestoHeader.record_reference && presupuestoHeader.record_reference_date"> (Expediente {{ presupuestoHeader.record_reference }} del {{ formatInvoiceDate(presupuestoHeader.record_reference_date) }})</b>
          <b v-else-if="presupuestoHeader.record_reference"> (Expediente {{ presupuestoHeader.record_reference }})</b>
          <b v-else-if="presupuestoHeader.record_reference_date"> (Fecha del expediente: {{ formatInvoiceDate(presupuestoHeader.record_reference_date) }})</b>
        </td>
      </tr>

      <!-- Invoice Lines -->
      <tr v-for="(item, index) in computed_lines" :key="index">
        <template v-if="index > page.firstPrintedLine && index <= page.lastPrintedLine">
          <!-- Normal line item -->
          <template v-if="!item.is_additional_info && !item.is_delivery_note_header">
            <td style="padding: 8px; border: 1px solid #E6E6E6;">{{ item.description }}</td>
            <td style="text-align: right; padding: 8px; border: 1px solid #E6E6E6;">{{ item.quantity }}</td>
            <td style="text-align: right; padding: 8px; border: 1px solid #E6E6E6; white-space: nowrap;">{{ formatCurrency(item.unit_price_without_tax) }}</td>
            <td style="text-align: right; padding: 8px; border: 1px solid #E6E6E6;">
              <span v-if="item.discounts && item.discounts.length > 0">{{ formatField(item.discounts[0].rate) }}</span>
              <span v-else>-</span>
            </td>
            <td style="text-align: right; padding: 8px; border: 1px solid #E6E6E6;">
              <span v-if="item.taxes && item.taxes.length > 0">{{ formatField(item.taxes[0].rate) }}</span>
              <span v-else>-</span>
            </td>
            <td style="text-align: right; padding: 8px; border: 1px solid #E6E6E6;">
              <span v-if="item.taxes_withheld && item.taxes_withheld.length > 0">{{ formatField(item.taxes_withheld[0].rate) }}</span>
              <span v-else>-</span>
            </td>
            <td style="text-align: right; padding: 8px; border: 1px solid #E6E6E6; white-space: nowrap;">{{ formatCurrency(get_total_amount(item)) }}</td>
          </template>

          <!-- Additional line information row -->
          <template v-if="item.is_additional_info">
            <td colspan="7" style="padding: 8px; border: 1px solid #E6E6E6; font-style: italic; color: #666;">
              <span v-if="item.additional_information && item.additional_information.additional_line_information" v-html="item.additional_information.additional_line_information.replace(/\\n/g, '<br>')"></span>
            </td>
          </template>
        </template>
      </tr>
    </tbody>
  </table>

  <!-- Totals Section -->
  <div v-if="pageIsTotals || isLastPage" style="margin-top: 24px; font-size: 13px;">
    <!-- Total sin descuentos (solo se muestra si hay descuento por línea, NO si hay descuento global) -->
    <div v-if="invoiceable.total_lines_discounts > 0" style="display: flex; justify-content: flex-end; margin-bottom: 6px;">
      <span style="width: 200px;">Total sin descuentos</span>
      <span style="width: 120px; text-align: right; padding: 4px; border: 1px solid #ccc; border-radius: 2px;">
        {{ formatCurrency(invoiceable.total_gross_amount) }}
      </span>
    </div>

    <!-- Descuento por línea -->
    <div v-if="invoiceable.total_lines_discounts > 0" style="display: flex; justify-content: flex-end; margin-bottom: 6px;">
      <span style="width: 200px;">Descuento por línea</span>
      <span style="width: 120px; text-align: right; padding: 4px; border: 1px solid #ccc; border-radius: 2px;">
        {{ formatCurrency(-invoiceable.total_lines_discounts) }}
      </span>
    </div>

    <!-- Total sin impuestos -->
    <div style="display: flex; justify-content: flex-end; margin-bottom: 6px;">
      <span style="width: 200px;">Total sin impuestos</span>
      <span style="width: 120px; text-align: right; padding: 4px; border: 1px solid #ccc; border-radius: 2px;">
        {{ formatCurrency(invoiceable.total_gross_amount_before_tax) }}
      </span>
    </div>

    <!-- Taxes -->
    <div v-for="(tax, idx) in invoiceable.total_taxes" :key="'tax-' + idx" style="display: flex; justify-content: flex-end; margin-bottom: 6px;">
      <span style="width: 200px;">Total {{tax_type_to_show}} {{ (tax.rate * 100).toFixed(2) }}% (Base: {{ formatCurrency(tax.base) }})</span>
      <span style="width: 120px; text-align: right; padding: 4px; border: 1px solid #ccc; border-radius: 2px;">
        {{ formatCurrency(tax.amount) }}
      </span>
    </div>

    <!-- Withholdings -->
    <div v-for="(withhold, idx) in invoiceable.total_taxes_withheld" :key="'with-' + idx" style="display: flex; justify-content: flex-end; margin-bottom: 6px;">
      <span style="width: 200px;">Total Retención {{ (withhold.rate * 100).toFixed(0) }}% (Base: {{ formatCurrency(withhold.base) }})</span>
      <span style="width: 120px; text-align: right; padding: 4px; border: 1px solid #ccc; border-radius: 2px;">
        {{ formatCurrency(-withhold.amount) }}
      </span>
    </div>

    <!-- Total invoice -->
    <div style="display: flex; justify-content: flex-end; margin-bottom: 6px;">
      <span style="width: 200px;">Total {{invoiceable.name}}</span>
      <span style="width: 120px; text-align: right; padding: 4px; border: 1px solid #ccc; border-radius: 2px;">
        {{ formatCurrency(invoiceable.total_amount) }}
      </span>
    </div>

    <!-- Descuento global (después del total factura, solo afecta al total a pagar) -->
    <div v-if="invoiceable.general_discounts && invoiceable.general_discounts.length > 0" style="display: flex; justify-content: flex-end; margin-bottom: 6px;">
      <span style="width: 200px;">Descuento global <small v-if="invoiceable.general_discounts[0].reason" style="color: gray; font-size: 0.9em;">({{ invoiceable.general_discounts[0].reason }})</small></span>
      <span style="width: 120px; text-align: right; padding: 4px; border: 1px solid #ccc; border-radius: 2px;">
        {{ formatCurrency(-invoiceable.general_discounts[0].amount) }}
      </span>
    </div>

    <!-- Retention -->
    <div v-if="invoiceable.retention_amount" style="display: flex; justify-content: flex-end; margin-bottom: 6px;">
      <span style="width: 200px;">Retención<span v-if="invoiceable.retention_concept">: {{ invoiceable.retention_concept }}</span></span>
      <span style="width: 120px; text-align: right; padding: 4px; border: 1px solid #ccc; border-radius: 2px;">
        {{ formatCurrency(-invoiceable.retention_amount) }}
      </span>
    </div>

    <!-- Reimbursable Expenses -->
    <div v-if="invoiceable.reimbursable_amounts && invoiceable.reimbursable_amounts.length > 0" style="display: flex; justify-content: flex-end; margin-bottom: 6px;">
      <span style="width: 200px;">Suplido<span v-if="invoiceable.reimbursable_expense_concept">: {{ invoiceable.reimbursable_expense_concept }}</span></span>
      <span style="width: 120px; text-align: right; padding: 4px; border: 1px solid #ccc; border-radius: 2px;">
        {{ formatCurrency(invoiceable.reimbursable_amounts[0]) }}
      </span>
    </div>

    <!-- Total to Pay -->
    <div style="display: flex; justify-content: flex-end; margin-bottom: 6px; font-weight: bold;">
      <span style="width: 200px; color: var(--v-primary_blue-base);">Total a pagar</span>
      <span style="width: 120px; text-align: right; padding: 6px; background-color: var(--v-primary_blue-base); color: white; border-radius: 2px;">
        {{ formatCurrency(invoiceable.total_to_pay) }}
      </span>
    </div>
  </div>

  <!-- Additional Info -->
  <div v-if="showAdditionalInfo && invoiceable.additional_info" style="margin-top: 24px; padding-left: 16px; white-space: pre-wrap; font-size: 11px;">
    <b>{{ invoiceable.additional_info }}</b>
  </div>

  <!-- Payment Info -->
  <div v-if="showPaymentMessage" style="margin-top: 8px; padding-left: 16px; font-size: 12px;">
    <span>{{ payment_message(invoiceable.payment_means) }}</span>
    <span v-if="invoiceable.payment_information">: ({{ invoiceable.payment_information }})</span>
  </div>

  <!-- Footer -->
  <div v-if="showFooter" style="margin-top: 8px; padding-left: 16px; font-size: 10px;">
    <small><b>{{ configuration.footer }}</b></small>
  </div>

  <!-- Footer Small -->
  <div v-if="showFooterSmall" style="margin-top: 8px; padding-left: 16px; font-size: 9px; color: #666;">
    <p style="margin: 0; line-height: 18px;">{{ configuration.footer_small }}</p>
  </div>
</div>`;
